<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Truck Fleet</h4>
                        
                    </div>
                    <div class="d-flex">
                                <!-- <a class="btn btn-primary ml-3 mr-3" (click)="positionCheck()">Position</a> -->
                                <!-- <a class="btn btn-primary ml-3 mr-3" (click)="positionCheckDrag()">assign Position</a> -->

                        <!-- <div class="tabs">
                            <a routerLink="/truck-mapping" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">All Orders</a>
                            <a routerLink="/orders/draft-order" routerLinkActive="active">Draft Order</a>
                        </div> -->
                        <!-- <a  *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-primary btn-sm ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Order</a> -->
                        <!-- *ngIf="accessControlService.canWrite('Budget')" -->
                        <button 
                         class="btn btn-primary btn-sm ms-3" (click)="addBudget('Add')" *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">+ Assemble New Truck</button>
                        <div class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Truck Fleet'" [exportApi]="getListExportApi"
                            [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>                              
                    </div>
                </div>
                 <!-- STAT CARDS -->
        <div class="stats-row">
        
        <div class="stat-card"  (click)="truckFilter('live')" [class.active]="selectedCard === 'live'">
            <div class="stat-icon si-green">✅</div>
            <div>
            <div class="stat-label">Assembled truck<br/>
                <span class="live-park">{{liveTruck}} Live / <span>{{parkedTruck}} Parked</span></span>
            </div>
            <div class="stat-num">{{liveTruck + parkedTruck}}</div>
            <div class="stat-sub">Fully assembled &amp; submitted</div>
            </div>
        </div>
        <div class="stat-card" (click)="truckFilter('drafts')" [class.active]="selectedCard === 'drafts'">
            <div class="stat-icon si-orange">📋</div>
            <div>
            <div class="stat-label">Drafts</div>
            <div class="stat-num">{{draftTruck}}</div>
            <div class="stat-sub">Pending completion</div>
            </div>
        </div>
        <div class="stat-card" (click)="truckFilter('tottal')" [class.active]="selectedCard === 'tottal'">
            <div class="stat-icon si-blue">🚛</div>
            <div>
            <div class="stat-label">Total Trucks</div>
            <div class="stat-num">{{totalTruck}}</div>
            <div class="stat-sub">All statuses</div>
            </div>
        </div>
        <div class="stat-card" (click)="truckFilter('compliance')" [class.active]="selectedCard === 'compliance'">
            <div class="stat-icon si-yellow">⚠️</div>
            <div>
            <div class="stat-label">Compliance Alerts</div>
            <div class="stat-num">{{complianceAlert}}</div>
            <div class="stat-sub">Expiring within 30 days</div>
            </div>
        </div>
        </div>
                <!-- <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true" [orderStatus]="true" [DateofPlacement]="true" [showCustomer]="true" [showVendor]="false"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <ng-container *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">
                                <ng-container *ngIf="selectedData[0]?.status == 'Draft' || selectedData[0]?.status == 'Created'">
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container>
                                </ng-container>
                                <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a>
                            </div>

                        </div>

                        <app-shared-table [componentName]="'orders'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)" (reloadEvent)="reloadEvent($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div> -->


        <!-- TOP BAR -->
        <!-- <div class="topbar">
        <div class="topbar-left">
            <h1>Truck Fleet</h1>
            <p>View, manage and assemble all trucks in your fleet.</p>
        </div>
        <div class="topbar-right">
            <button class="btn btn-outline">↓ Export</button>
            <button class="btn btn-primary">+ Assemble New Truck</button>
        </div>
        </div> -->
<div class="card">
                    <div class="card-body">
       

        <!-- FILTER BAR -->
        <!-- <div class="filter-bar">
        <div class="filter-left">
            <button class="tab-btn active-live" onclick="setTab(this,'live')">
            <span class="tab-live-dot"></span> Live Trucks <span class="tab-count">118</span>
            </button>
            <button class="tab-btn" onclick="setTab(this,'draft')">
            <span class="tab-draft-icon">📋</span> Draft Trucks <span class="tab-count">24</span>
            </button>
        </div>
        <div class="filter-right">
            <div class="search-box">
            <span class="search-icon">🔍</span>
            <input type="text" placeholder="Search truck, model, dealer…" />
            </div>
            <button class="btn btn-outline btn-sm">⚙ Filters</button>
            <button class="btn btn-outline btn-sm">↕ Sort</button>
        </div>
        </div> -->

        <!-- BULK ACTION BAR -->
        <div class="bulk-bar" id="bulkBar">
             <!-- [truckModel]="true"  [truckBrand]="true" -->
            <app-filter (filterChange)="onFilterChange($event)"  [truckNumber]="true"  
            [pollutionNumber]="true" [insuranceNumber]="true" [statusFilter]="true" [showVendor]="true"
                (resetFilters)="onResetFilters()">
            </app-filter>

            <div class="bulk-actions">
            <ng-container>
                <!-- <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedRows?.length ?? 0) > 0" (click)="editEvent()">Edit</a> -->
            </ng-container>
            <button class="btn btn-primary btn-sm"  (click)="addComponentPopUp()" [disabled]="selectedRows.length === 0">+ Add Component</button>
            <button class="btn btn-primary btn-sm"  (click)="removeComponentPopUp()" [disabled]="selectedRows.length === 0">— Remove Component</button>
            <button class="btn btn-primary btn-sm"  (click)="exchangeComponentPopUp()" [disabled]="selectedRows.length === 0">⇄ Exchange Component</button>
            <button class="btn btn-primary btn-sm"  (click)="swapComponentPopUp()" >⇄ Swap Component</button>
        </div>
        <!-- <span class="bulk-close" onclick="document.getElementById('bulkBar').style.display='none'">✕</span> -->
        </div>



        <!-- TABLE -->
        <div class="table-wrap">
          <div class="table-fleet">
        <table>
            <thead>
            <tr>
                <th></th>
                <th (click)="sortData('truckNumber')">TRUCK NO <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th>TRAILER NUMBER</th>
                <th>BRAND </th>
                <th >MODEL </th>
                <th *ngIf="selectedCard !== 'compliance'">Horse TYRES</th>
                <th *ngIf="selectedCard !== 'compliance'">Trailer TYRES</th>
                <th *ngIf="selectedCard !== 'compliance'">BATTERIES</th>
                <th (click)="sortData('registrationValidityTill')">RC Validity Till <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('puc')">PUC <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('insuranceNumber')">INSURANCE <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th colspan="">Status</th>
                <th colspan="" *ngIf="selectedCard !== 'compliance'">DEALER NAME</th>
                <th colspan="">Odometer Reading</th>
                <!-- <th (click)="sortData('createdAt')">ASSEMBLY DATE <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th> -->
                <!-- <th (click)="sortData('updatedAt')">LAST MODIFIED <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th> -->
                <th colspan="4" style="width: 300px;">ACTION</th>
            </tr>
            </thead>
            <tbody>

            <!-- ROW 1 — selected -->
            <tr class="" *ngFor="let item of tableLists">
                <td>
                    <!-- <input type="checkbox" class="cb"  /> -->
                <p-checkbox class="form-check-input"  [(ngModel)]="item.selected" (onChange)="onRowSelect(item)"
                [binary]="true"></p-checkbox></td>
                <td><a class="truck-link" (click)="openDetail(item?.id)">{{item?.truckNumber}}</a></td>
                <td>{{item?.isHorse ? item?.fleetNumber : 'Not applicable'}}</td>
                <td><div class="brand-name"  (click)="openDetail(item?.id)">{{item?.truckBrand}}</div></td>
                <td><span class="type-tag">{{item?.truckModel}}</span></td>
                <td *ngIf="selectedCard !== 'compliance'">
                    <!-- <span class="comp-pill type-tag">No of Tyre : {{item?.tyreCapacity}}</span>
                    <span class="comp-pill cp-blue">Min Required: {{item?.minimumTyreForRunning}}</span>
                    <span class="comp-pill cp-green">Associated Tyre: {{item?.associatedTyres}}</span> -->
                    <span class="comp-pill"  [ngClass]="item?.associatedTyres >= item?.minimumTyreForRunning ? 'cp-green':'cd-expired'">{{item?.associatedTyres}}/{{item?.minimumTyreForRunning}}</span>

                </td>
                <td *ngIf="selectedCard !== 'compliance'">
                    <!-- <span class="comp-pill type-tag">No of Tyre : {{item?.trailerTyreCapacity}}</span>
                    <span class="comp-pill cp-blue">Min Required: {{item?.minimumTrailerTyreForRunning}}</span>
                    <span class="comp-pill cp-green">Associated Tyre: {{item?.associatedTrailerTyres}}</span> -->

                    <span class="comp-pill" *ngIf="item?.associatedTrailerTyres" [ngClass]="item?.associatedTrailerTyres >= item?.minimumTrailerTyreForRunning ? 'cp-green':'cd-expired'">{{item?.associatedTrailerTyres}}/{{item?.minimumTrailerTyreForRunning}}</span>
                </td>
                <td *ngIf="selectedCard !== 'compliance'">
                    <!-- <span class="comp-pill type-tag">No of Battery : {{item?.batteryCapacity}}</span>
                    <span class="comp-pill cp-blue">Min Required: {{item?.minimumBatteryForRunning}}</span>
                    <span class="comp-pill cp-green">Associated Battery: {{item?.associatedBatteries}}</span> -->

                    <span class="comp-pill"  [ngClass]="item?.associatedBatteries >= item?.minimumBatteryForRunning ? 'cp-green':'cd-expired'">{{item?.associatedBatteries}}/{{item?.minimumBatteryForRunning}}</span>
                </td>
                <td>
                    <span class="comp-date" [ngClass]="getValidityClass(item?.registrationValidityTill)">{{item?.registrationValidityTill | CustomDatePipe : 'D-M-YYYY'}}</span>
                </td>
                <td>
                    <span class="comp-date" [ngClass]="getValidityClass(item?.pucValidityTill)">{{item?.puc}}</span>
                    <div class="dealer-code">{{item?.pucValidityTill | CustomDatePipe : 'D-M-YYYY'}} </div>
                </td>
                <td>
                    <span class="comp-date" [ngClass]="getValidityClass(item?.insuranceValidityTill)">{{item?.insuranceNumber}}
                    </span>
                    <div class="dealer-code">{{item?.insuranceValidityTill | CustomDatePipe : 'D-M-YYYY'}}</div>
                </td>
                 <td class="dealer-name" >
                   <ng-container *ngIf="item?.status != 'Draft'">
                       <span class="comp-pill cp-green" [ngClass]="
                        {
                            'cp-green': item?.status === 'Running',
                            'cp-orange': item?.status === 'Parked',
                            'cp-draft': item?.status === 'Draft',
                            'successPill': item?.status === 'Approved',
                             
                        }">
                        <!-- <span class="cp-dot"></span> -->
                        {{item?.status}}</span>
                   </ng-container>
                    <div class="event-list" *ngIf="item?.status == 'Draft'">
                    <!-- <div class="event-list"> -->
                        <button class="btn btn-outline btn-sm"  (click)="editTruck(item,false)" style="width:100%;justify-content:center;border-color:#ea580c;color:#ea580c" onmouseover="this.style.background='#fff7ed'" onmouseout="this.style.background=''">▶ Resume Draft</button>
                    </div>
                </td>
                <td *ngIf="selectedCard !== 'compliance'" class="dealer-name">{{item?.vendorName}}<div class="dealer-code">{{item?.vendorCode}}</div></td>
                <td>{{item?.initialKmTravelled ? item?.initialKmTravelled : '0'}}</td>
               
                
               
                <!-- <td *ngIf="selectedCard !== 'compliance'"><div class="date-val">{{item?.createdAt | CustomDatePipe: 'D-M-YYYY'}}</div></td> -->
                <!-- <td><div class="date-val">{{item?.updatedAt | CustomDatePipe: 'D-M-YYYY'}}</div></td> -->
                <td>
                    <div class="action-btn">
                        <a class="btn btn-primary" (click)="ViewHistory(item)">View History</a>
                        <a class="btn btn-primary" (click)="editTruck(item, true)">Tyre Position</a>
                        <a class="btn btn-primary" (click)="updateOdometer(item)">Update Odometer</a>
                    </div>
                </td>
            </tr>

            <tr *ngIf="tableLists.length == 0">
                <td colspan="13"><span style="color: red;">
                    {{
                    selectedCard === 'drafts' ? 'No draft trucks available' :
                    selectedCard === 'tottal' ? 'No trucks found in records' :
                    selectedCard === 'compliance' ? 'No compliance alerts found' :
                    selectedCard === 'live' ? 'No assembled trucks available' :
                    'No records found'
                    }}
                </span></td>
            </tr>


            </tbody>
        </table>
</div>  
        <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

   
        </div>

        <div style="height:24px"></div>

            </div>
        </div>
    </div>
</div>



<div [ngClass]="odometerReadingShow ? 'show':''"  class="expenseattributePopUp">
    <div class="expenseattribute">
        <h3>Update Odometer Reading <a (click)="closeOdometerPopup()" class="closeAttributePopup"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a></h3>
         <!-- STEP 2 -->
            <div class="step-section">
                <div class="form-row three-col">
                    <div class="form-group">
                        <label class="form-label req">Odometer Reading</label>
                        <input class="form-input" type="text" (keypress)="sharedService.isNumberOnly($event)"  [(ngModel)]="initialKmTravelled" />
                    </div>
                    <div class="form-group">
                       <div class="field">
                            <label class="field-label">Upload PUC (PDF, JPG, PNG) <span class="required-dot">*</span></label>
                            <div class="file-upload">
                            <!-- <div class="file-icon">📄</div> -->
                            <div class="file-text">
                                <input type="file" id="uploads" name="uploads" (change)="selectFile($event,'odometerReadingUrl')"  accept=".pdf, .jpg, .jpeg, .png, .svg"  #odometerReadingInput>
                            </div>
                            <div class="uploadFile" *ngIf="odometerReadingUrl != null && odometerReadingUrl != ''">
                                <span class="file-icon">
                                <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                        <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                                        </g>
                                    </svg>
                                </span>
                                <a class="clossfile" (click)="removeFile('odometerReadingUrl')"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-dialog-header-close-icon p-icon" aria-hidden="true"><path d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z" fill="currentColor"></path></svg></a>
                            </div>
                            </div> 
                        </div>
                    </div>
                </div>

                  <!-- Footer -->
                <div class="modal-footer">
                    <div class="footer-actions">
                    <button class="btn btn-cancel" (click)="closeOdometerPopup()">Cancel</button>
                    <button class="btn btn-primary" (click)="updateOdometerData()" >
                        Update
                    </button>
                    </div>
                </div>
            </div>
    </div>
</div>